import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ReportHeaderSnippet } from '../models/report-definition';

@Component({
   selector: 'app-report-summary-header',
   standalone: true,
   imports: [CommonModule, NgOptimizedImage],
   templateUrl: './report-summary-header.component.html',
   styleUrls: ['./report-summary-header.component.scss']
})
export class ReportSummaryHeaderComponent {
   @Input() title = '';
   @Input() businessDateLabel = 'Business Date';
   @Input() businessDateText = '';
   @Input() snippets: ReportHeaderSnippet[] = [];
   @Input() totalReportValueText = '';

   getSnippetToneClass(snippet: ReportHeaderSnippet): string {
      return `tone-${snippet.tone ?? 'neutral'}`;
   }
}
